var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"color":"green","dark":""},on:{"click":_vm.onNewRequestClick}},on),[_c('v-icon',[_vm._v("mdi-plus")]),_vm._v("\n      New Request\n    ")],1)]}}])},[_c('span',[_vm._v("Create new leave request")])])}
var staticRenderFns = []

export { render, staticRenderFns }